(function () {
    'use strict';

    angular
        .module('core')
        .controller('LoginController', LoginController)

    /** @ngInject */
    function LoginController($window, $location, $rootScope, $state, $httpParamSerializerJQLike, AuthenticationService, ApplicationService,
        ApplicationAuthService, LoadingHelper, sweetAlert, UtilHelper, LOCAL_STORAGE_ITEMS) {
        const vm = this;
        let redirectData;
        let canRedirect = false;

        vm.login = () => {
            LoadingHelper.startLoading('.loading-holder');

            const loginData = {
                UserName: vm.loginData.Login,
                Password: Encrypt.Hash(vm.loginData.Password).toString(),
                grant_type: 'password'
            }

            AuthenticationService
                .login(loginData)
                .then(success => {
                    localStorage.setItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN, success.access_token);
                    localStorage.setItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_REFRESH, success.refresh_token);
                    localStorage.setItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_EXPIRATION, moment().add(success.expires_in, 'seconds').format('YYYY-MM-DD HH:mm:ss'));

                    handleUserOauthRedirect(success);

                    $rootScope.hideLoading = false;

                    $state.go('app.home');

                    LoadingHelper.stopLoading('.loading-holder');
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.loading-holder');
                })
        }

        init();

        function handleOauthRedirect() {
            redirectData = $location.search();

            $location.search({});

            if (redirectData.ClientId && redirectData.RedirectUrl) {
                LoadingHelper.startLoading('.loading-holder');

                const validateData = {
                    ClientId: redirectData.ClientId,
                    CallbackUrl: redirectData.RedirectUrl
                }

                ApplicationService
                    .validateCallbackUrl(validateData)
                    .then(() => {
                        canRedirect = true;

                        if (AuthenticationService.isLogged()) {
                            const hoursToExpire = moment(localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_EXPIRATION)).diff(moment(), 'hours');

                            if (hoursToExpire >= 2) {
                                handleUserOauthRedirect({
                                    access_token: localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN),
                                    expires_in: moment(localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_EXPIRATION)).diff(moment(), 'seconds')
                                });
                            } else
                                LoadingHelper.stopLoading('.loading-holder');
                        } else
                            LoadingHelper.stopLoading('.loading-holder');
                    }, () => {
                        LoadingHelper.stopLoading('.loading-holder');

                        sweetAlert.swal({
                            title: 'Ação não permitida',
                            text: 'As configurações de retorno não estão entre as permitidas para realizar essa ação',
                            type: 'warning',
                            confirmButtonText: 'Ok',
                            showCancelButton: false,
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then(() => {
                            $window.location.reload();
                        })
                    });
            } else {
                handleLoggedUser();
            }
        }

        function handleLoggedUser() {
            if (AuthenticationService.isLogged())
                $state.go('app.home');
        }

        function handleUserOauthRedirect(success) {
            if (canRedirect) {
                if (ApplicationAuthService.isAuthValid()) {
                    ApplicationAuthService.setAuthTry(redirectData.ClientId);

                    $window.location.href = `${redirectData.RedirectUrl}?${$httpParamSerializerJQLike(success)}`;

                    return;
                } else {
                    sweetAlert.swal({
                        title: 'Erro na autenticação!',
                        text: 'A autenticação dessa aplicação está com problemas, entre em contato com nosso suporte.',
                        type: 'warning',
                        confirmButtonText: 'Ok',
                        showCancelButton: false,
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then(() => {
                        handleLoggedUser();
                        ApplicationAuthService.resetAuth();
                        LoadingHelper.stopLoading('.loading-holder');
                    })
                }
            }
        }

        function handleQueryString(){

            if($location.search().access_token && $location.search().refresh_token)
            {
                localStorage.setItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN, $location.search().access_token);
                localStorage.setItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_REFRESH, $location.search().refresh_token);
                localStorage.setItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_EXPIRATION, moment().add(1, 'days').format('YYYY-MM-DD HH:mm:ss'));
            }
        }

        function init() {
            handleQueryString();

            handleOauthRedirect();

            $rootScope.authenticationWrapperLarger = false;
        }
    }
}());